import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Stats from '../components/Stats';
import About from '../components/About';
import Products from '../components/Products';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <Services />
        <Stats />
        <About />
        <Products />
        <Contact />
      </main>
    </div>
  );
};

export default Home;
